import {every} from 'lodash'
import clsx from 'clsx'
import React from 'react'
import { makeStyles, withStyles} from 'external/material'
import Grid from '@mui/material/Grid'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Checkbox from '@mui/material/Checkbox'
import Card from '@mui/material/Card'
import Divider from '@mui/material/Divider'
import CardHeader from '@mui/material/CardHeader'

const useStyles = makeStyles(theme => ({
  card: {
    flexGrow: 1,
    border: 'solid 1px #b0b0b0',
    boxShadow: 'none',
    overflowY: 'auto',
    height: '100%',
    flexGrow: 1
  }
}))


function ListElem (props) {
  const {id, label, checked, onClick} = props
  const labelId = `transfer-list-item-${id}-label`
  return (
    <ListItem role="listitem" button onClick={onClick} className={props.className}>
      <ListItemIcon>
        <Checkbox
          checked={checked}
          tabIndex={-1}
          disableRipple
          inputProps={{ 'aria-labelledby': labelId }}
        />
      </ListItemIcon>
      <ListItemText id={labelId} primary={label} />
    </ListItem>
   )
}

export default function CheckList (props) {
  const classes = useStyles()
  const {
    checklist,
    selectAllTitle,
    id = elem => typeof(elem) == 'object' ? elem.id : elem,
    label = elem => typeof(elem) == 'object' ? elem.label : elem,
    ListItem = ListElem,
    onChecked
  } = props

  const isChecked = elem => checklist.indexOf(id(elem)) >= 0
  const isNotChecked = elem => checklist.indexOf(id(elem)) < 0

  const items = props.items.map(item => ({id: id(item), checked: isChecked(item), item}))

  const createItem = ({id, checked, item}) => {
    return (<ListItem
      key={id}
      id={id}
      label={label(item)}
      checked={checked}
      className={clsx({[classes.checked]: checked})}
      onClick={() => {
        const left = items.filter(i => i.id != id && !i.checked).map(i => i.item)
        const right = items.filter(i => i.id != id && i.checked).map(i => i.item)
        if (checked) onChecked({left: [...left, item], right})
        else onChecked({left, right: [...right, item]})
      }}
    />)
  }

  const allChecked = every(items, item => item.checked)
  const noneChecked = every(items, item => !item.checked)
  const someChecked = !allChecked && !noneChecked

  return (
    <Card className={classes.card}>
      <CardHeader
        className={classes.cardHeader}
        avatar={
          <Checkbox
            onClick={() => {
              if (noneChecked || someChecked) onChecked({left: [], right: [...props.items]})
              else onChecked({left: [...props.items], right: []})
            }}
            checked={allChecked}
            indeterminate={someChecked}
            disabled={items.length === 0}
            inputProps={{ 'aria-label': 'all items selected' }}
          />
        }
        title={selectAllTitle}
      />
      <Divider />
      <List dense component="div" role="list">
        {items.map(createItem)}
      </List>
    </Card>
  )
}
